<template>
    <div class="somaticTree-container" :style="'height:' + clientH +'px'">
        <slot name="btn" />

        <div class="somaticTree_body">
            <h1>Показатели соматического статуса</h1>
            <div class="body_age">
                <div class="age-top">
                    <p ref="ageTxt" class="age-txt">Возраст </p>

                    <v-slider
                        class="slider-thumbs-custom"
                        :class="{ 'female': sex, 'male': !sex }"
                        :min="1"
                        :max="18"
                        v-model="ageOnMonth"
                        :tick-labels="tickLabelsSlider"
                        step="1"
                        thumb-label="always"
                        :thumb-size="34"
                        :color="sex ? '#E882DD' : '#717BF9'"
                        :track-color="sex ? '#E882DD' : '#717BF9'"
                    >
                        <template v-slot:thumb-label></template>
                    </v-slider>

                    <div class="age_switch-container">
                        <p :class="{'male':!sex}">M</p>
                        <v-switch
                            v-model="sex"
                            color="#E882DD"
                        >
                        </v-switch>
                        <p :class="{'female':sex}">Ж</p>
                    </div>
                </div>
            </div>

            <div class="body-info">
                <div class="chapter-container" :style="'height:' + (clientH-344) +'px'">
                    <div class="chapter">
                        <p class="chapter-head">Системы организма</p>
                        <v-list class="py-0" shaped lines="three">
                            <v-list-item-group v-model="selectedItem">
                                <v-list-item v-for="(item, i) in listSystem" :key="i" :color="selectedItem === i && !sex ? '#4854FE' : '#E882DD' " @click="tapList(item, i)">
                                    <v-list-item-icon>
                                        <v-avatar size="36" tile>
                                            <inline-svg :src="getIcon(item.icon)" />
                                        </v-avatar>
                                    </v-list-item-icon>
                                    <v-list-item-content class="listWidth">
                                        <v-list-item-title>
                                            <span class="chapter-txt">{{ item.name }}</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </div>
                </div>

                <div class="d-flex" style="position:relative;width:74%;">

                    <div
                        class="body-text-s"
                        :style="'height:' + (clientH-344) +'px'"
                        :class="{
                            'w-80': showImage,
                            'w-100': !showImage
                        }"
                    >
                        <v-scroll-x-transition group hide-on-leave>
                            <v-card flat v-if="active" :key="items && items[0] ? items[0].name : 1">
                                <v-card-text class="py-0 my-0">
                                    <v-row>
                                        <v-col cols="12" md="8" v-if="!active">
                                            <span class="defaultTxt">Выберите систему организма</span>
                                        </v-col>

                                        <v-col cols="12" md="8">
                                            <div v-for="(selection, i) in filterProperties(items, ageOnMonth*12*30)" :key="'A'+i">
                                                <h2>{{ i }}</h2>
                                                <ul>
                                                    <li v-for="(item, key) in selection" :key="'B'+key">
                                                        <span class="text-item">
                                                             {{ item.name }}, {{ item.value }}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-scroll-x-transition>

                    </div>

                    <div class="body-img" v-if="showImage">
                        <v-card-text class="py-0 my-0 text-center">
                            <humanImage
                                :ageOnMonth="ageOnMonth"
                                :gender="sex"
                                :activeName="activeName"
                                :dialogSomaticName="dialogSomaticName"
                                :heightOffset="386"
                            />
                        </v-card-text>
                    </div>

                    <v-overlay absolute opacity="0.3" :value="loadData">
                        Загрузка данных...
                        <v-progress-circular indeterminate size="24" />
                    </v-overlay>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './index.scss'
import humanImage from "../../Student/HumanImage.vue";
import InlineSvg from 'vue-inline-svg';
import { mapGetters } from 'vuex'

export default {
    name: 'SomaticStatus',
    props: {
        listSystem: { type: Array, default: () => [] },
        defaultDataDS: { type: Array, default: () => [] }
    },
    components: { humanImage, InlineSvg },
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl'
        }),
        showImage() {
            if(
                this.activeName !== 'Антропометрические показатели' &&
                this.activeName !== 'Витальные показатели' &&
                this.activeName !== 'Лабораторные исследования'
            ) return true

            return false;
        }
    },
    watch: {
        sex() {
            this.tapList(this.active, this.selectedItem);
        }
    },
    data() {
        return {
            loadData: false,
            tickLabelsSlider: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18],
            dialogSomaticName: null,
            ageOnMonth: 1,
            clientH: 688,
            selectedItem: null,
            clickShow: true,
            sex: false,
            width: 0,
            items: [{ name: '' }],
            active: null,
            activeName: null,
            tapLevel1index: null,
        }
    },
    methods: {
        tapList(item, index) {
            let sex = this.sex ? [1, 2] : [0, 2];
            this.loadData = true;
            this.selectedItem = index;
            this.activeName = item.name;

            if(index === 0) {
                this.$http.post(`${this.apiUrl}Dictionary/GetAnthropometricIndicators`, sex)
                    .then((res) => {
                    this.sortArray(res.data, 'sortOrder')
                        this.items = [
                            {
                                name: 'Общее',
                                properties: res.data
                            }
                        ];
                        this.loadData = false;
                        this.active = item;
                    })
                return;
            }
            if(index === 1) {
                this.$http.post(`${this.apiUrl}Dictionary/GetVitalIndicators`, sex)
                    .then((res) => {
                        this.sortArray(res.data, 'sortOrder')
                        this.items = [
                            {
                                name: 'Общее',
                                properties: res.data
                            }
                        ];
                        this.loadData = false;
                        this.active = item;
                    })
                return;
            }
            if(index === 2) {
                this.$http.post(`${this.apiUrl}Dictionary/GetLabResearches`, sex)
                    .then((res) => {
                        this.sortArray(res.data, 'sortOrder')
                        this.items = res.data;
                        this.loadData = false;
                        this.active = item;
                    })
                return;
            }

            this.$http.post(`${this.apiUrl}Dictionary/GetSomaticStatuses?bodySystemId=${item.id}`, sex)
                .then((res) => {
                    this.items = this.sortArray(res.data, 'sortOrder');
                    for (let i = 0; i < res.data.length; i++) {
                        this.sortArray(res.data[i].properties, 'sortOrder')
                    }
                    this.loadData = false;
                    this.active = item;
                })
        },
        getIcon(name) {
            if(name) return require(`../../../assets/SomaticStatus/${name}`)
            return ''
        },
        sortArray(array, name){
          return array.sort((prev, next) => {
              const nameA = typeof prev[name] === 'string' ? prev[name].toUpperCase() : prev[name];
              const nameB = typeof next[name] === 'string' ? next[name].toUpperCase() : next[name];

              if (nameA < nameB) return -1;
              if (nameA > nameB) return 1;
              return 0;
          })
      },
        filterProperties(array, ageOnDay) {
            if(array.length > 0) {
                let res = [];

                for (let i = 0; i < array.length; i++) {
                    for (let j = 0; j < array[i].properties.length; j++) {

                        let left = 0, right = array[i].properties[j].ageValues.length - 1;

                        while(left <= right) {
                            let middle = Math.floor((left+right) / 2), currentIteration = array[i].properties[j].ageValues[middle];

                            if (currentIteration.ageOnDay < ageOnDay) {
                                left = middle + 1;
                            } else if (currentIteration.ageOnDay > ageOnDay) {
                                right = middle - 1;
                            } else {
                                left = middle
                                break;
                            }
                        }

                        if(array[i].properties[j].ageValues[left] && array[i].properties[j].ageValues[left].ageOnDay == ageOnDay) {
                            res.push({
                                groupName: array[i].name,
                                name: array[i].properties[j].name ,
                                value: this.returnResult(array[i].properties[j].ageValues[left])
                            })
                        } else if(array[i].properties[j].ageValues[left-1] && array[i].properties[j].ageValues[left-1].ageOnDay < ageOnDay) {
                            res.push({
                                groupName: array[i].name,
                                name: array[i].properties[j].name,
                                value: this.returnResult(array[i].properties[j].ageValues[left-1])
                            })
                        }
                    }
                }

                return res.reduce((group, product) => {
                    const { groupName } = product;
                    group[groupName] = group[groupName] ?? [];
                    group[groupName].push(product);

                    return group;
                }, {})
            }

            return {'Данных нет': []}
        },
        returnResult(obj) {
            let res = '';

            if(obj.valueType == 0) {
                if(obj.valueTo) {
                    res = `${obj.measurementName ? obj.measurementName+': ' : ''}${obj.valueFrom}-${obj.valueTo}`
                } else {
                    res = `${obj.measurementName ? obj.measurementName+': От ' : ''}${obj.valueFrom}`
                }
            } else if(obj.valueType == 1) {
                if(obj.listValues && obj.listValues.length > 0) {
                    res = obj.listValues.map((m) => m.name).join(', ');
                    // console.log('if', res);
                }
            }

            return res
        },
    },
    created() {
        this.tapList({ id: 111, name: 'Антропометрические показатели', ord: 11, icon: 'ap.svg' }, 0)
        this.clientH = window.innerHeight;
    }
}
</script>
